@if (!columns || columns.length === 0) {
<div class="animate-pulse p-4 space-y-3">
  <div class="flex gap-3 pb-3 border-b border-line">
    <div class="h-3 bg-line rounded flex-1"></div>
    <div class="h-3 bg-line rounded flex-1"></div>
    <div class="h-3 bg-line rounded flex-1"></div>
    <div class="h-3 bg-line rounded w-20"></div>
  </div>
  @for (i of skeletonRows; track i) {
  <div class="flex items-center gap-3 rounded-lg bg-page/40 px-3 py-2">
    <div class="h-7 w-7 bg-line rounded-lg"></div>
    <div class="h-3 bg-line rounded flex-1"></div>
    <div class="h-3 bg-line rounded flex-1"></div>
    <div class="h-3 bg-line rounded w-20"></div>
  </div>
  }
</div>
} @else {
<div class="centaiva-table-shell" [style.--centaiva-table-height]="tableHeight">

  @if (showToolbar) {
  <div
    class="flex flex-col sm:flex-row sm:items-center gap-2.5 sm:gap-3 px-3 sm:px-4 py-2.5 border-b border-line bg-card">
    @if (dataPeriodLabel) {
    <div
      class="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-line bg-page px-2.5 py-1.5 text-[11px] font-semibold text-dim"
      title="Date range for the displayed data">
      <i class="pi pi-calendar text-[10px] text-primary" aria-hidden="true"></i>
      <span>Data period: {{ dataPeriodLabel }}</span>
    </div>
    }
    @if (globalFilterFields.length > 0) {
    <div class="relative w-full sm:w-64 shrink-0">
      <i class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-[11px] text-muted"></i>
      <input type="text" [ngModel]="searchTerm" (ngModelChange)="onSearch($event)" (paste)="onSearchPaste($event)"
        [placeholder]="searchPlaceholder"
        class="w-full pl-8 pr-8 py-1.5 rounded-lg border border-line bg-page text-xs text-ink placeholder:text-muted focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition-colors"
        aria-label="Search table" />
      @if (searchTerm) {
      <button type="button"
        class="absolute right-2 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded text-muted transition-colors hover:bg-line hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary"
        (click)="clearSearch()" aria-label="Clear table search" title="Clear search">
        <i class="pi pi-times text-[9px]" aria-hidden="true"></i>
      </button>
      }
    </div>
    }
    @if (filtersTemplate) {
    <div class="flex items-center gap-2 flex-wrap">
      <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
    </div>
    }
    @if (filterFields.length > 0) {
    <div class="flex min-w-0 flex-1 items-center gap-2">
      @if (filterFields.length > 4) {
      <select
        class="h-8 max-w-48 shrink-0 rounded-md border border-line bg-page px-2 text-[11px] font-semibold text-ink focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
        [ngModel]="selectedFilterField" (ngModelChange)="selectFilterField($event)" aria-label="Choose filter field">
        @for (field of filterFields; track field) {
        <option [ngValue]="field">{{ filterFieldLabel(field) }}</option>
        }
      </select>
      } @else if (filterFields.length > 1) {
      <div class="inline-flex shrink-0 overflow-hidden rounded-md border border-line bg-page p-0.5">
        @for (field of filterFields; track field) {
        <button type="button" class="rounded px-2 py-1 text-[10px] font-semibold transition-colors"
          [class.bg-primary]="selectedFilterField === field" [class.text-white]="selectedFilterField === field"
          [class.text-dim]="selectedFilterField !== field" [class.hover:bg-primary-bg]="selectedFilterField !== field"
          (click)="selectFilterField(field)">{{ filterFieldLabel(field) }}</button>
        }
      </div>
      }
      <div class="relative"
        [ngClass]="isDateColumn(selectedFilterField) ? 'w-[164px] flex-none' : 'min-w-[150px] max-w-xs flex-1'">
        @if (isDateColumn(selectedFilterField)) {
        <p-datepicker class="block w-[164px]" [style]="{ width: '164px' }" [ngModel]="fieldSearchDate"
          (ngModelChange)="onDateFieldSearch($event)" dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" [showIcon]="true"
          [readonlyInput]="true" iconDisplay="input" icon="pi pi-calendar" appendTo="body"
          inputStyleClass="h-7 w-[164px] cursor-pointer rounded-md border border-line bg-page py-0 pl-2 pr-9 text-[11px] font-medium text-ink outline-none focus:border-primary focus:ring-1 focus:ring-primary"
          [attr.aria-label]="'Choose ' + filterFieldLabel(selectedFilterField).toLowerCase()" />
        } @else if (isOptionFilterField(selectedFilterField)) {
        <select [ngModel]="fieldSearchTerm" (ngModelChange)="onFieldSearch($event)"
          class="h-7 w-full rounded-md border border-line bg-page px-2 text-[11px] font-medium text-ink outline-none focus:border-primary focus:ring-1 focus:ring-primary"
          [attr.aria-label]="'Choose ' + filterFieldLabel(selectedFilterField).toLowerCase()">
          <option value="">All {{ filterFieldLabel(selectedFilterField).toLowerCase() }}s</option>
          @for (option of filterOptionValues(selectedFilterField); track option) {
          <option [value]="option">{{ option }}</option>
          }
        </select>
        } @else {
        <input type="text" [ngModel]="fieldSearchTerm" (ngModelChange)="onFieldSearch($event)"
          (paste)="onFieldSearchPaste($event)"
          [placeholder]="'Search ' + filterFieldLabel(selectedFilterField).toLowerCase()"
          class="h-7 w-full rounded-md border border-line bg-page py-0 pl-2 pr-7 text-[11px] font-medium text-ink placeholder:text-muted outline-none focus:border-primary focus:ring-1 focus:ring-primary"
          [attr.aria-label]="'Search by ' + filterFieldLabel(selectedFilterField).toLowerCase()" />
        }
        @if (fieldSearchTerm && !isOptionFilterField(selectedFilterField)) {
        <button type="button"
          class="absolute top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded text-muted transition-colors hover:bg-line hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary"
          [class.right-8]="isDateColumn(selectedFilterField)" [class.right-1.5]="!isDateColumn(selectedFilterField)"
          (click)="clearFieldSearch()"
          [attr.aria-label]="'Clear ' + filterFieldLabel(selectedFilterField).toLowerCase() + ' filter'"
          title="Clear filter">
          <i class="pi pi-times text-[9px]" aria-hidden="true"></i>
        </button>
        }
      </div>
    </div>
    }
    @if (showExport && summaryItems.length > 0) {
    <div class="ml-auto flex flex-wrap items-center justify-end gap-1.5">
      @for (item of summaryItems; track item.label) {
      <span class="inline-flex h-8 items-center gap-2 rounded-md border border-primary/25 bg-primary-bg px-2.5">
        <span class="text-[9px] font-bold uppercase tracking-wide text-dim">{{ item.label }}</span>
        <strong class="text-xs font-bold text-primary tabular-nums">{{ item.value }}</strong>
      </span>
      }
    </div>
    }
    @if (toolbarEndTemplate) {
    <div class="ml-auto flex shrink-0 items-center gap-2">
      <ng-container *ngTemplateOutlet="toolbarEndTemplate"></ng-container>
    </div>
    }
    @if (showColumnSelector) {
    <details class="relative" [class.ml-auto]="!toolbarEndTemplate">
      <summary
        class="inline-flex h-7 cursor-pointer list-none items-center gap-1.5 rounded-md border border-line bg-card px-2.5 text-[11px] font-semibold text-dim shadow-sm transition-colors hover:border-primary hover:bg-primary-bg hover:text-primary">
        <i class="pi pi-sliders-h text-[10px]"></i>
        <span>Columns</span>
      </summary>
      <div
        class="absolute right-0 z-50 mt-1 max-h-72 min-w-64 overflow-y-auto rounded-lg border border-line bg-card p-2 shadow-xl">
        @for (col of orderedColumns; track col.field) {
        <div class="flex items-center gap-2 rounded px-2 py-1.5 text-xs text-ink hover:bg-primary-bg">
          <input type="checkbox" class="accent-primary" [checked]="isColumnVisible(col.field)"
            [disabled]="isColumnVisible(col.field) && visibleColumns.length === 1" (change)="toggleColumn(col.field)" />
          <span class="min-w-0 flex-1 truncate">{{ col.header }}</span>
        </div>
        }
      </div>
    </details>
    }
    @if (showExport) {
    @if (summaryValue) {
    <span
      class="inline-flex h-8 items-center gap-2 rounded-md border border-primary/25 bg-primary-bg px-2.5 tabular-nums"
      [class.ml-auto]="summaryItems.length === 0">
      @if (summaryLabel) {
      <span class="text-[9px] font-bold uppercase tracking-wide text-dim">{{ summaryLabel }}</span>
      }
      <strong class="text-xs font-bold text-primary">{{ summaryValue }}</strong>
    </span>
    }
    @if (showZeroBalanceToggle) {
    <details class="relative">
      <summary
        class="inline-flex h-7 w-7 cursor-pointer list-none items-center justify-center rounded-md border border-line bg-card text-dim shadow-sm transition-colors hover:border-primary hover:bg-primary-bg hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
        aria-label="Table display options" title="Table display options">
        <i class="pi pi-ellipsis-v text-[11px]" aria-hidden="true"></i>
      </summary>
      <div
        class="absolute right-0 z-50 mt-1 min-w-64 rounded-lg border border-line bg-card p-3 shadow-xl">
        <p class="mb-2 text-[10px] font-semibold text-dim">Include accounts with</p>
        <label class="flex cursor-pointer items-center gap-2 text-xs font-medium text-ink">
          <input type="checkbox" class="h-4 w-4 accent-primary"
            [ngModel]="includeZeroBalanceOrActivity"
            (ngModelChange)="onIncludeZeroBalanceChange($event)" />
          <span>Zero balance or activity</span>
        </label>
      </div>
    </details>
    }
    <button type="button"
      class="inline-flex h-7 shrink-0 items-center gap-1.5 rounded-md border border-line bg-card px-2.5 text-[11px] font-semibold text-dim shadow-sm transition-colors hover:border-primary hover:bg-primary-bg hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50"
      [class.ml-auto]="!showColumnSelector && !summaryValue && summaryItems.length === 0" [disabled]="displayedRows.length === 0"
      (click)="exportExcel()" aria-label="Export table to Excel" title="Export to Excel">
      <i class="pi pi-download text-[10px]"></i>
      <span>Export</span>
    </button>
    }
  </div>
  }

  <p-table #dt [value]="displayedRows" [defaultSortOrder]="1" [customSort]="usesCustomSort"
    [style.--table-min-width]="tableMinWidth"
    (sortFunction)="sortRows($event)" [first]="pageFirst" [paginator]="showPaginator"
    [alwaysShowPaginator]="showPaginator" [rows]="effectivePageSize" [pageLinks]="3" [showFirstLastIcon]="false"
    [rowHover]="true" [reorderableColumns]="columnsReorderable" (onColReorder)="onColumnReorder($event)"
    [globalFilterFields]="globalFilterFields" [selectionMode]="selectionMode" [(selection)]="selection"
    (selectionChange)="selectionChange.emit($event)" (onPage)="onPage($event)" (onFilter)="onTableFilter($event)" paginatorStyleClass="centaiva-paginator"
    [styleClass]="'p-datatable-sm centaiva-table text-xs sm:text-sm'
            + (zebra ? ' centaiva-table--zebra' : '')
            + (compact ? ' centaiva-table--compact' : '')
            + (fitColumns ? ' centaiva-table--fit-columns' : '')
            + (tableMinWidth ? ' centaiva-table--stable-columns' : '')">
    <ng-template pTemplate="paginatorleft">
      <div class="centaiva-paginator-summary">
        <span class="centaiva-paginator-total text-xs font-semibold text-dim">
          Total {{ recordName }}: {{ filteredRecordCount }}
        </span>

        @if (showPageSizeSelector) {
        <label class="centaiva-page-size-control">
          <span class="centaiva-page-size-prefix">Show</span>
          <select class="centaiva-page-size-select" [ngModel]="pageSizeSelection ?? pageSize"
            (ngModelChange)="onPageSizeChange($event)" [attr.aria-label]="'Records shown per page for ' + recordName">
            @for (size of pageSizeOptions; track size) {
            <option [ngValue]="size">{{ size }}</option>
            }
            @if (showAllPageSizeOption) {
            <option [ngValue]="'all'">All</option>
            }
          </select>
          <span class="centaiva-page-size-suffix">records</span>
        </label>
        }
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="selectionMode === 'multiple'" style="width: 3rem"
          class="centaiva-column-separator px-2 py-2 sm:px-4 sm:py-3">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th *ngIf="selectionMode === 'single'" style="width: 3rem"
          class="centaiva-column-separator px-2 py-2 sm:px-4 sm:py-3"></th>
        @for (col of visibleColumns; track col.field; let first = $first) {
        <th pReorderableColumn [pReorderableColumnDisabled]="!columnsReorderable"
          [pSortableColumn]="isSortable(col.field) ? col.field : undefined"
          class="centaiva-column-separator relative whitespace-nowrap px-2 py-2 font-medium uppercase tracking-wider text-dim sm:px-4 sm:py-3 text-[10px] sm:text-[11px]"
          [ngClass]="first ? 'sticky left-0 z-10 bg-card' : null" [class.border-x]="highlightedColumn === col.field"
          [class.border-t]="highlightedColumn === col.field"
          [class.centaiva-highlighted-col]="highlightedColumn === col.field || !!col.headerColor"
          [style.--hl-bg]="col.headerColor || (highlightedColumn === col.field ? (highlightColor || 'var(--color-primary-bg)') : null)"
          [style.--hl-color]="col.headerColor ? '#ffffff' : (highlightedColumn === col.field ? (highlightColor ? '#ffffff' : 'var(--color-primary)') : null)"
          [style.width]="col.width ?? null" [attr.aria-current]="highlightedColumn === col.field ? 'true' : null">
          <span class="inline-flex items-center gap-1.5 whitespace-nowrap">
            <span>{{ col.header }}</span>
            @if (isSortable(col.field)) {
            <span class="inline-flex min-w-3 items-center justify-center text-xs font-bold text-muted"
              [class.text-primary]="dt.sortField === col.field" [attr.aria-label]="dt.sortField === col.field
                        ? (dt.sortOrder === 1 ? 'Sorted ascending' : 'Sorted descending')
                        : 'Not sorted'">{{ dt.sortField === col.field ? (dt.sortOrder === 1 ? '↑' : '↓') : '↕' }}</span>
            }
          </span>
        </th>
        }
        @if (hasActionColumn) {
        <th class="centaiva-action-column w-12 shrink-0 whitespace-nowrap px-2 py-2 sm:px-4 sm:py-3"></th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr class="group/row transition-all duration-200" [class.centaiva-table-row--highlighted]="isRowHighlighted(row)"
        (contextmenu)="onRowContextMenu($event, row)" [pSelectableRow]="row">
        <td *ngIf="selectionMode === 'multiple'" class="centaiva-column-separator px-2 py-2 sm:px-4 sm:py-3"
          (click)="$event.stopPropagation()">
          <p-tableCheckbox [value]="row"></p-tableCheckbox>
        </td>
        <td *ngIf="selectionMode === 'single'" class="centaiva-column-separator px-2 py-2 sm:px-4 sm:py-3"
          (click)="$event.stopPropagation()">
          <p-tableRadioButton [value]="row"></p-tableRadioButton>
        </td>
        @for (col of visibleColumns; track col.field; let first = $first) {
        <td class="centaiva-column-separator relative whitespace-nowrap px-2 py-2 sm:px-4 sm:py-3"
          [ngClass]="first ? 'sticky left-0 z-10 bg-card' : null" [class.border-x]="highlightedColumn === col.field"
          [class.centaiva-highlighted-col]="highlightedColumn === col.field"
          [class.centaiva-date-column]="isDateColumn(col.field)"
          [class.centaiva-compact-text-column]="isCompactTextColumn(col.field)"
          [class.centaiva-compact-identifier-column]="isCompactIdentifierColumn(col.field)"
          [class.centaiva-compact-amount-column]="isCompactAmountColumn(col.field)"
          [class.centaiva-content-width-column]="isContentWidthColumn(col.field)"
          [class.centaiva-date-column]="isDateColumn(col.field)"
          [class.centaiva-compact-text-column]="isCompactTextColumn(col.field)"
          [class.centaiva-compact-identifier-column]="isCompactIdentifierColumn(col.field)"
          [class.centaiva-compact-amount-column]="isCompactAmountColumn(col.field)"
          [class.centaiva-content-width-column]="isContentWidthColumn(col.field)"
          [style.--hl-bg]="highlightedColumn === col.field ? (highlightColor ? highlightBg : 'var(--color-primary-bg)') : null"
          [style.--hl-color]="highlightedColumn === col.field ? (highlightColor || 'var(--color-primary)') : null"
          [style.width]="col.width ?? null">
          @if (first) {
          <span
            class="absolute left-0 top-1/2 h-8 w-1 -translate-y-1/2 rounded-r-full bg-primary/0 transition-colors group-hover/row:bg-primary"></span>
          }
          <div class="inline-flex max-w-full items-center gap-2 min-w-0" [pTooltip]="displayValue(row, col.field)"
            tooltipPosition="bottom" appendTo="body" [showDelay]="250">
            @if (cellTemplate) {
            <ng-container *ngTemplateOutlet="cellTemplate; context: {
                      $implicit: row,
                      col: col,
                      toggleExpansion: toggleExpansionFromCell,
                      expanded: isExpandedFromCell(row)
                    }"></ng-container>
            } @else {
            @if (isNumericEmphasisField(col.field)) {
            <span class="font-bold text-ink tabular-nums">{{ displayValue(row, col.field) }}</span>
            } @else if (statusField && col.field === statusField) {
            <span [ngClass]="statusBadge(row[col.field])">{{ row[col.field] }}</span>
            } @else {
            <span class="truncate" [class.font-semibold]="first" [class.text-ink]="first">{{ displayValue(row,
              col.field) }}</span>
            }
            }
          </div>
        </td>
        }
        @if (hasActionColumn) {
        <td
          class="centaiva-action-column w-12 shrink-0 whitespace-nowrap overflow-visible px-2 py-2 sm:px-4 sm:py-3 text-right">
          @if (rowExpansionTemplate) {
          <button type="button"
            class="relative z-20 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded border border-primary/30 bg-primary-bg text-primary shadow-sm transition-all hover:border-primary hover:bg-primary hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
            [attr.aria-expanded]="isRowExpanded(row)"
            [attr.aria-label]="isRowExpanded(row) ? 'Collapse details' : 'Expand details'"
            [title]="isRowExpanded(row) ? 'Collapse details' : 'Expand details'"
            (click)="toggleRowExpansion($event, row)">
            <i class="pi pi-chevron-down text-[9px] font-bold transition-transform duration-200"
              [class.rotate-180]="isRowExpanded(row)"></i>
          </button>
          } @else if (isRowActionEnabled(row)) {
          <button type="button"
            class="relative z-20 inline-flex h-7 w-7 shrink-0 touch-manipulation items-center justify-center rounded-md border border-primary/30 bg-primary-bg text-primary shadow-sm transition-all hover:border-primary hover:bg-primary hover:text-white hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
            aria-label="Open details" title="Open details" (pointerdown)="onRowActionPointerDown($event, row)"
            (click)="onRowActionClick($event, row)">
            <i class="pi pi-external-link text-[11px] font-bold"></i>
          </button>
          }
        </td>
        }
      </tr>
      @if (rowExpansionTemplate && isRowExpanded(row)) {
      <tr class="centaiva-expanded-row">
        <td [attr.colspan]="visibleColumns.length + (selectionMode ? 1 : 0) + (hasActionColumn ? 1 : 0)" class="p-0">
          <ng-container *ngTemplateOutlet="rowExpansionTemplate; context: { $implicit: row }"></ng-container>
        </td>
      </tr>
      }
    </ng-template>

    <ng-template pTemplate="footer">
      @for (slot of placeholderRows; track slot) {
      <tr class="centaiva-placeholder-row pointer-events-none select-none" aria-hidden="true">
        @for (col of visibleColumns; track col.field; let first = $first) {
        <td class="centaiva-column-separator relative whitespace-nowrap px-2 py-2 sm:px-4 sm:py-3"
          [ngClass]="first ? 'sticky left-0 z-10 bg-card' : null" [class.border-x]="highlightedColumn === col.field"
          [class.centaiva-highlighted-col]="highlightedColumn === col.field"
          [class.centaiva-date-column]="isDateColumn(col.field)"
          [class.centaiva-compact-text-column]="isCompactTextColumn(col.field)"
          [class.centaiva-compact-amount-column]="isCompactAmountColumn(col.field)"
          [class.centaiva-content-width-column]="isContentWidthColumn(col.field)"
          [style.--hl-bg]="highlightedColumn === col.field ? (highlightColor ? highlightBg : 'var(--color-primary-bg)') : null"
          [style.--hl-color]="highlightedColumn === col.field ? (highlightColor || 'var(--color-primary)') : null">
          <span class="invisible">-</span>
        </td>
        }
        @if (hasActionColumn) {
        <td class="centaiva-action-column w-12 shrink-0 whitespace-nowrap px-2 py-2 sm:px-4 sm:py-3 text-right">
          <span class="invisible">-</span>
        </td>
        }
      </tr>
      }
      @if (grandTotalValues) {
      <tr
        class="border-y-2 border-primary/50 bg-primary-bg shadow-[inset_0_1px_0_color-mix(in_srgb,var(--color-primary)_18%,transparent)]">
        @if (selectionMode) {
        <td class="centaiva-column-separator bg-primary-bg px-2 py-2 sm:px-4 sm:py-3"></td>
        }
        @for (col of visibleColumns; track col.field; let first = $first) {
        <td class="centaiva-column-separator bg-primary-bg px-2 py-2 text-xs font-extrabold text-ink sm:px-4 sm:py-3"
          [ngClass]="first ? 'sticky left-0 z-10' : null"
          [class.text-center]="grandTotalValues[col.field] === 'Grand Total'"
          [class.text-primary]="grandTotalValues[col.field] === 'Grand Total'">
          {{ grandTotalValues[col.field] }}
        </td>
        }
        @if (hasActionColumn) {
        <td class="centaiva-action-column w-12 bg-primary-bg px-2 py-2 sm:px-4 sm:py-3"></td>
        }
      </tr>
      }
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="visibleColumns.length + (rowClick.observed && showRowActions ? 1 : 0)"
          class="text-center py-12">
          <div class="mx-auto flex max-w-sm flex-col items-center gap-3 text-dim">
            <div
              class="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-bg text-primary ring-1 ring-primary/10">
              <i class="pi pi-inbox text-lg"></i>
            </div>
            <div>
              <p class="text-sm font-semibold text-ink">No data available</p>
              <p class="mt-1 text-xs text-dim">Try clearing filters or running a fresh sync.</p>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
}
